import { Rows03 } from '@/components/Icons'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils'

interface TFLSidebarTOCButtonProps {
  isOnTOCPage: boolean
  isActive: boolean
  onClick: () => void
  onKeyDown?: (e: React.KeyboardEvent) => void
}

export const TFLSidebarTOCButton = ({
  isOnTOCPage,
  isActive,
  onClick,
  onKeyDown,
}: TFLSidebarTOCButtonProps) => {
  return (
    <button
      className={cn(
        'sticky top-0 z-10 border-0 bg-transparent w-full p-0',
        !isOnTOCPage && 'cursor-pointer hover:bg-gray-50 bg-white'
      )}
      onClick={onClick}
      role={isOnTOCPage ? undefined : 'button'}
      tabIndex={isOnTOCPage ? undefined : 0}
      onKeyDown={onKeyDown}
    >
      <button
        type="button"
        className={cn(
          'flex justify-start items-center gap-2 pr-2 pl-4 py-3 self-stretch cursor-pointer bg-transparent border-none w-full text-left',
          isActive ? 'bg-tertiary' : 'bg-transparent'
        )}
        onClick={() => onClick()}
        aria-label="Go to table of contents"
      >
        <Badge
          variant="ghost"
          size="iconMd"
          className={cn(
            'flex-shrink-0 text-secondary-700 rounded-sm bg-quaternary',
            isOnTOCPage && 'text-primary-900'
          )}
        >
          <Rows03
            className={cn(
              'size-3 text-quaternary-500',
              isOnTOCPage && 'text-primary-600'
            )}
          />
        </Badge>
        <span
          className={cn(
            'text-sm font-normal tracking-wide text-secondary-700',
            isOnTOCPage && 'text-primary-900',
            isActive ? 'font-medium' : ''
          )}
        >
          Table of contents
        </span>
      </button>
    </button>
  )
}
